var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 8,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.827.188a.604.604 0 0 0-.856 0L4.003 3.145 1.037.178a.604.604 0 1 0-.856.855L3.147 4 .177 6.967a.604.604 0 1 0 .856.856l2.969-2.966 2.965 2.97a.604.604 0 1 0 .856-.856L4.858 4.002l2.968-2.965a.61.61 0 0 0 0-.85"
})));
export default SvgClose;